import { createRouter, createWebHistory } from 'vue-router';
import MartinThierry from '@/components/MartinThierry.vue';
import Meta from '@/composables/useMeta';

const routes = [
  {
    path: '/',
    name: 'Accueil',
    component: MartinThierry,
  },
  {
    path: '/:section',
    name: 'Section',
    component: MartinThierry,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Utiliser la classe Meta pour la gestion de l'URL canonique
const meta = new Meta();

router.beforeEach((to, from, next) => {
  next();
});

router.afterEach((to) => {
  // Mettre à jour l'URL canonique après chaque navigation
  meta.updateCanonicalUrl(to.path);
});

export default router;
